import React from 'react';
import { Trans } from '@lingui/react';
import { FormattedMarkdown } from '@qover/react-intl';
import { Tooltip as BaseToolTip } from '@qover/molecules';
import Icon from '@qover/icons/Icon';
import {
  AnswerParagraph,
  Contact,
  Documents,
  DocumentsListItem,
  Warranties,
} from './bikeAccordionFaq.styles';

function Tooltip(props: { id: string }) {
  return props.id ? (
    <BaseToolTip id={props.id}>
      <FormattedMarkdown id={props.id} />
    </BaseToolTip>
  ) : null;
}

const warranties = {
  title: <Trans id="bike.accordion.info1.title" />,
  description: (
    <Warranties
      id="bike.accordion.info1.description"
      options={{ overrides: { Tooltip: Tooltip, Icon: Icon } }}
    />
  ),
};

const exclusions = {
  title: <Trans id="bike.accordion.info2.title" />,
  description: (
    <AnswerParagraph
      className="list-col list-col-2"
      id="bike.accordion.info2.description"
    />
  ),
};

const compensation = {
  title: <Trans id="bike.accordion.info3.title" />,
  description: (
    <AnswerParagraph
      className="list-col"
      id="bike.accordion.info3.description"
    />
  ),
};

const sinister = {
  title: <Trans id="bike.accordion.info4.title" />,
  description: (
    <AnswerParagraph
      id="bike.accordion.info4.description"
      options={{
        overrides: {
          a: (props: any) => (
            <a
              {...props}
              className={props.className ? `${props.className} sm` : 'sm'}
              rel="noopener noreferrer"
              target="_blank"
            />
          ),
        },
      }}
    />
  ),
};

const documents = {
  title: <Trans id="bike.accordion.info5.title" />,
  description: (links: {
    generalConditions: string;
    IPID: string;
    privacyPolicy: string;
    fullFaq: string;
  }) => (
    <Documents
      id="bike.accordion.info5.description"
      options={{ overrides: { li: DocumentsListItem } }}
      values={{
        generalConditions: links.generalConditions,
        IPID: links.IPID,
        privacyPolicy: links.privacyPolicy,
        fullFaq: links.fullFaq,
      }}
    />
  ),
};

const insurance = {
  title: <Trans id="bike.accordion.info6.title" />,
  description: <AnswerParagraph id="bike.accordion.info6.description" />,
};

const termination = {
  title: <Trans id="bike.accordion.info7.title" />,
  description: <AnswerParagraph id="bike.accordion.info7.description" />,
};

const contact = {
  title: <Trans id="bike.accordion.info8.title" defaults="Contactez-nous" />,
  description: (
    <Contact
      id="bike.accordion.info8.description"
      options={{
        overrides: {
          a: (props: any) => (
            <a
              {...props}
              className={props.className ? `${props.className} sm` : 'sm'}
              onClick={
                props.href === '#open-chat'
                  ? e => {
                      e.preventDefault();
                      // @ts-ignore
                      window.$zopim?.livechat?.window?.show();
                    }
                  : undefined
              }
              rel="noopener noreferrer"
              target="_blank"
            />
          ),
        },
      }}
    />
  ),
};

export const content1 = {
  cardInfo1: warranties,
  cardInfo2: exclusions,
  cardInfo3: compensation,
  cardInfo4: sinister,
  cardInfo5: documents,
  cardInfo6: insurance,
  cardInfo7: termination,
  cardInfo8: contact,
};
